import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Injector,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Store } from '@sama/app-state';
import { matches } from '@sama/micro-dash';
import { DirectiveSuperclass } from '@sama/ng-core';
import { MessagingService } from '../../cross-team-shared/messaging/messaging.service';
import { SensorRendererState } from '../../outputs/annotation/annotation-shared/state/root/sensor-renderer-state';
import { EventTrackingService } from '../../shared/event-tracking/event-tracking.service';
import { Output } from '../../team-apis/otterdam/outputs/output';
import { CustomJsService } from '../h3ml/custom-js.service';
import { H3mlStore } from '../h3ml/state/h3ml-store';
import {
  getValuesForOutputContext,
  OutputInfo,
  outputInfoStoreToken,
} from '../h3ml/state/output-info';
import { TaskWorkspaceStore } from '../h3ml/state/task-workspace-store';

// https://github.com/ng-packagr/ng-packagr/issues/696#issuecomment-373487183
// @dynamic
@Component({
  selector: 'h3-naked-output',
  templateUrl: './naked-output.component.html',
  styleUrls: ['./naked-output.component.scss'],
  providers: [
    EventTrackingService,
    {
      provide: outputInfoStoreToken,
      deps: [NakedOutputComponent],
      useFactory: (self: NakedOutputComponent) => self.outputInfoStore,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NakedOutputComponent
  extends DirectiveSuperclass
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input() focusOnInit?: boolean;
  @Input({ required: true }) name!: string;
  output?: Output;
  outputInfoStore?: Store<OutputInfo>;
  sensorRendererStore?: Store<SensorRendererState>;
  idAttribute!: string;

  constructor(
    private customJsService: CustomJsService,
    private elementRef: ElementRef,
    private eventTrackingService: EventTrackingService,
    private messaging: MessagingService,
    private store: H3mlStore,
    private taskWorkspaceStore: TaskWorkspaceStore,
    injector: Injector,
  ) {
    super(injector);
  }

  ngOnInit() {
    const state = this.store.state();
    const outputs = state.project.outputs;
    this.output = outputs.find(matches({ name: this.name }));

    if (!this.output) {
      this.messaging.error(
        `The layout contains an invalid output name: ${this.name}`,
      );
      return;
    }

    this.idAttribute = `output-${this.output.id}`;
    this.outputInfoStore = this.store('outputInfoByName')(this.name);
    this.sensorRendererStore = this.taskWorkspaceStore('outputAnnotationInfo')(
      this.name,
      // @ts-ignore -- fix me
    )('sensorRendererState');
    this.eventTrackingService.addContext(
      getValuesForOutputContext(this.output),
    );
    this.subscribeTo(this.store('task')('id').$, this.notifyCustomJsOfChange);
  }

  ngAfterViewInit() {
    if (this.outputInfoStore) {
      this.outputInfoStore.assign({ isVisible: true });
    }
  }

  ngOnDestroy() {
    if (this.outputInfoStore) {
      this.outputInfoStore.assign({
        isVisible: false,
        unsubmittableReason: undefined,
      });
    }
  }

  private notifyCustomJsOfChange() {
    setTimeout(() => {
      // delay until after the output content is updated
      this.customJsService.withErrorHandling(() => {
        const customJs = this.store.state().customJs;
        // fix me if you change this code
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix me!
        if (customJs && customJs.onOutputRendered) {
          customJs.onOutputRendered(
            this.name,
            $(this.elementRef.nativeElement).closest('h3-output'),
          );
        }
      });
    });
  }
}
